import Typography from '@mui/material/Typography';

const PageTitle = ({ titleText }) => {
  return (
    <Typography variant="h6" noWrap component="div">
      {titleText}
    </Typography>
  );
};

export default PageTitle;